import { render, staticRenderFns } from "./resultado-de-busqueda.vue?vue&type=template&id=a4a99e16&scoped=true&"
import script from "./resultado-de-busqueda.vue?vue&type=script&lang=js&"
export * from "./resultado-de-busqueda.vue?vue&type=script&lang=js&"
import style0 from "./resultado-de-busqueda.vue?vue&type=style&index=0&id=a4a99e16&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a99e16",
  null
  
)

export default component.exports